const { createInspirationTiles } = require('../../shop/tiles/inspiration-tile-factory'), { mergeInspirationTiles } = require('../../shop/tiles/merge-inspiration-tiles');

class InspirationDetailTileListController {
    constructor($location, $q, analyticsService, inspirationService) {
        this.$location = $location;
        this.$q = $q;
        this.analyticsService = analyticsService;
        this.inspirationService = inspirationService;
    }

    createTiles(pageCards, urlCards) {
        return {
            items: mergeInspirationTiles(createInspirationTiles(pageCards, 'inspirationdetail'), urlCards, { type: 'inspirationdetail' }),
        };
    }

    getTiles() {
        return this.$q.all([
            this.inspirationService.getCardsByPageID(this.pageId),
            this.inspirationService.getCardsForUrl(this.$location.pathAndSearch()),
        ])
            .then(([{ InspirationCards: pageCards }, { Cards: urlCards }]) => {
                this.analyticsService.push({ type: this.analyticsService.mapperTypes.content.general });
                return this.createTiles(pageCards, urlCards);
            });
    }
}

InspirationDetailTileListController.$inject = ['$location', '$q', 'AnalyticsService', 'InspirationService'];

const inspirationDetailTileListComponentDefinition = {
    bindings: {
        pageId: '<',
    },
    controller: InspirationDetailTileListController,
    template: `
        <wow-tile-list
            should-get-inspiration-cards="false"
            get-tiles="$ctrl.getTiles()">
        </wow-tile-list>
    `,
};

module.exports = {
    InspirationDetailTileListController,
    inspirationDetailTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/inspiration/tile/inspiration-detail-tile-list.component.js